export const sleeptimeFilterOptions = [
  { value: 0, label: "sleep-time-filter-option-early-sleeping-time" },
  { value: 1, label: "sleep-time-filter-option-mid-sleeping-time" },
  { value: 2, label: "sleep-time-filter-option-late-sleeping-time" },
];
